'use strict';

/**
 * A directive that will execute an expression if a click is registered outside of its element.
 * Inspired by https://stackoverflow.com/a/17342418/396618
 */
customerZone.directive('onClickOutside', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs, ctrl) {
            $(document).on('click', function(event){
                var isClickedElementChildOfPopup = element
                    .find(event.target)
                    .length > 0;

                if (isClickedElementChildOfPopup)
                    return;

                scope.$apply(attrs.onClickOutside);
            });
        }
    };
});
